/* global __CLIENT__*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import { AuthActions } from '../../actions/auth';
import Input from '../../components/form/InputField';
import { UserActions } from '../../actions/user';
import { validateAndDispatch } from '../../helpers/form';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { currentUserSelector } from '../../reducers/users';
import logo from '../../static/img/planz-logo-white.svg';
import '../../styles/Login.css';

if (__CLIENT__) {
  // require('../styles/Login.css');
}

// @reduxForm({
//   form: 'register',
// })
class Register extends Component {
  static propTypes = {
    user: PropTypes.object,
    authenticate: PropTypes.func.isRequired,
    login: PropTypes.func,
    logout: PropTypes.func,
    intl: PropTypes.object,
  };

  handleSubmit = (values, dispatch) => {
    const { reset, hash } = this.props;
    const validation = {
      firstName: [{ rule: 'required', label: 'First Name' }],
      lastName: [{ rule: 'required', label: 'Last Name' }],
      password: [{ rule: 'required', label: 'User role' }, 'minLength:8'],
      hash: [{ rule: 'required', label: 'Registration hash' }],
    };

    values.hash = hash;
    const { password } = values;

    return validateAndDispatch(
      dispatch,
      UserActions.register(values),
      validation,
      values,
    ).then(result => {
      const { result: { email } } = result;
      reset();
      this.props.authenticate(email, password);
    });
  };

  redirect = () => {
    const { dispatch } = this.props;

    dispatch(push(`/login`));
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="wrapper">
        <div className="login2">
          <img src={logo} className="loginLogo" width={300} alt="Sight Logo" />
          <h1 style={{ color: '#fff' }}>Register</h1>
          <form
            className="login-form"
            onSubmit={handleSubmit(this.handleSubmit)}
          >
            <div className="form-group">
              <Field
                name="firstName"
                component={Input}
                type="text"
                className="form-control"
                placeholder="First Name"
                autoFocus="true"
                ref="displayName"
              />
            </div>
            <div className="form-group">
              <Field
                name="lastName"
                component={Input}
                type="text"
                className="form-control"
                placeholder="Last Name"
                autoFocus="true"
                ref="displayName"
              />
            </div>
            {/* <FieldError field={displayName} /> */}
            <div className="form-group">
              <Field
                name="password"
                component={Input}
                type="password"
                className="form-control"
                placeholder="Password"
                autoFocus="true"
              />
            </div>
            {/* <FieldError field={password} /> */}
            <div
              style={{
                color: '#fff',
                fontSize: 14,
                marginTop: 10,
                marginBottom: 20,
                textAlign: 'center',
                maxWidth: 350,
              }}
            >
              By clicking Signup, you agree to our{' '}
              <a
                style={{ color: '#5e97be' }}
                href="http://community.sightplanner.com/content/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>{' '}
              and{' '}
              <a
                style={{ color: '#5e97be' }}
                href="http://community.sightplanner.com/content/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy.
              </a>
            </div>
            <button
              type="submit"
              className="btn btn-primary loginBtn"
              onClick={handleSubmit(this.handleSubmit.bind(this))}
              disabled={submitting}
            >
              Register
            </button>
            <div
              style={{
                color: '#fff',
                fontSize: 14,
                marginTop: 10,
                textAlign: 'center',
              }}
            >
              Already Registered?{' '}
              <a onClick={this.redirect}>Click here to login.</a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const registerFormSelector = state => {
  const selector = formValueSelector('register');
  return selector(state, 'displayName', 'password');
};

const RegisterSelector = immutableCreatorSelector(
  [registerFormSelector, currentUserSelector],
  (registerForm, user) => ({
    fields: registerForm,
    user,
  }),
);

@connect(RegisterSelector)
@reduxForm({
  form: 'register',
})
export default class LoginContainer extends Component {
  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object,
  };

  render() {
    const { user, dispatch, params: { hash } } = this.props;
    return (
      <Register
        user={user}
        hash={hash}
        {...this.props}
        {...bindActionCreators(AuthActions, dispatch)}
      >
        {this.props.children}
      </Register>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/public/Register.js